export const BUILTIN_ROOM_TYPES = [
    {
        id: "builtin-hotel-room",
        name: "Hotel room",
        category: "room",
        screenRole: "tv",
    },
    {
        id: "builtin-streaming-only",
        name: "Streaming only",
        category: "room",
        screenRole: "tv",
    },
    {
        id: "builtin-private-room",
        name: "Private room",
        category: "room",
        screenRole: "tv",
    },
    {
        id: "builtin-door-sign",
        name: "Door sign",
        category: "room",
        screenRole: "door-sign",
    },
    {
        id: "builtin-private-area",
        name: "Private area",
        category: "room",
        screenRole: "signage",
    },
    {
        id: "builtin-common-area",
        name: "Common area (TV)",
        category: "common_area",
        screenRole: "tv",
    },
    {
        id: "builtin-common-area-signage",
        name: "Common area (signage)",
        category: "common_area",
        screenRole: "signage",
    },
    {
        id: "builtin-public-viewing",
        name: "Public viewing",
        category: "public",
        screenRole: "signage",
    },
];
const BY_ID = new Map(BUILTIN_ROOM_TYPES.map((t) => [t.id, t]));
export function builtinRoomType(id) {
    return BY_ID.get(id);
}
export function isBuiltinRoomTypeId(id) {
    return BY_ID.has(id);
}
export function screenRoleForRoomType(roomType) {
    var _a;
    return (roomType && ((_a = BY_ID.get(roomType)) === null || _a === void 0 ? void 0 : _a.screenRole)) || "tv";
}
export function isSignageRoomType(roomType) {
    return screenRoleForRoomType(roomType) === "signage";
}
export const DOOR_SIGN_ROOM_TYPE = "builtin-door-sign";
export function roomTypesForPremise(input) {
    const products = new Set(input.products);
    const care = products.has("care") || input.segment === "care";
    const allowed = new Set();
    if (care) {
        allowed.add("builtin-private-room");
        allowed.add("builtin-door-sign");
        allowed.add("builtin-common-area");
    }
    else if (products.has("frontlayer")) {
        allowed.add("builtin-hotel-room");
    }
    if (products.has("streaming-tv"))
        allowed.add("builtin-streaming-only");
    if (products.has("signage")) {
        allowed.add("builtin-private-area");
        allowed.add("builtin-common-area-signage");
        allowed.add("builtin-public-viewing");
    }
    if (allowed.size === 0)
        allowed.add("builtin-hotel-room");
    return BUILTIN_ROOM_TYPES.filter((t) => allowed.has(t.id));
}
